import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getBulkActionLogs } from "../../../services/api/bulkActions/bulkActionsApi";

export const fetchBulkActionLogs = createAsyncThunk(
  "bulkActions/fetchBulkActionLogs",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await getBulkActionLogs(params);
      const logs = response?.data?.data || {};

      return {
        logs: Array.isArray(logs.data) ? logs.data : [],
        pagination: {
          current_page: logs.current_page || 1,
          last_page: logs.last_page || 1,
          total: logs.total || 0,
          per_page: logs.per_page || 10,
        },
      };
    } catch (error) {
      return rejectWithValue("Failed to fetch bulk action logs");
    }
  },
);

const initialState = {
  logs: [],
  currentPage: 1,
  lastPage: 1,
  totalLogs: 0,
  perPage: 10,
  loading: false,
  error: null,
};

const bulkActionsSlice = createSlice({
  name: "bulkActions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBulkActionLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBulkActionLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload.logs || [];
        state.currentPage = action.payload.pagination.current_page;
        state.lastPage = action.payload.pagination.last_page;
        state.totalLogs = action.payload.pagination.total;
        state.perPage = action.payload.pagination.per_page;
      })
      .addCase(fetchBulkActionLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default bulkActionsSlice.reducer;
